var render = function render(){var _vm=this,_c=_vm._self._c;return _c('widget-settings-item',{attrs:{"title":_vm.$t('settings.infoPopup.title')}},[_c('v-btn',{staticClass:"primary",attrs:{"small":""},on:{"click":_vm.edit}},[_vm._v(" "+_vm._s(_vm.$t('common.create'))+"/"+_vm._s(_vm.$t('common.edit'))+" ")])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }